/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EmployedTimeType {
    FULL_TIME = 'FullTime',
    PART_TIME = 'PartTime',
}
